export const PERMISSIONS = [
  {
    module: 'admins',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'addresses',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'activity_sessions',
    actions: ['list', 'group', 'details']
  },
  {
    module: 'attempted_orders',
    actions: ['list', 'group', 'details']
  },
  {
    module: 'authors',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'billing',
    actions: ['list', 'group', 'details', 'approve', 'reject']
  },
  {
    module: 'blogs',
    actions: ['list', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'branches',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore', 'add_user', 'remove_user']
  },
  {
    module: 'brands',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'campaigns',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'carts',
    actions: ['list', 'details']
  },
  {
    module: 'chat_sessions',
    actions: ['list', 'details']
  },
  {
    module: 'sms_gateways',
    actions: ['list', 'group', 'details', 'create', 'update']
  },
  {
    module: 'ip_blocks',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'delivery_methods',
    actions: ['list', 'group', 'details', 'create', 'update']
  },
  {
    module: 'delivery_location_types',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'coupons',
    actions: ['list', 'group', 'details', 'check_usability', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'categories',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'customers',
    actions: ['list', 'group', 'details', 'create', 'update']
  },
  {
    module: 'couriers',
    actions: ['create_parcel', 'cancel_parcel', 'track_parcel']
  },
  {
    module: 'genres',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'media',
    actions: ['list', 'group', 'create_folder', 'upload_image', 'upload_document', 'upload_video', 'delete', 'delete_folder', 'add_external', 'restore', 'restore_folder', 'permanent_delete', 'permanent_delete_folder', 'move', 'move_folder']
  },
  {
    module: 'offers',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'orders',
    actions: ['list', 'group', 'details', 'place', 'change_status', 'change_return_status', 'update_order_discount', 'update_item_discount', 'add_coupon', 'remove_coupon', 'update_customer_info', 'update_delivery_info', 'add_item', 'update_item_quantity', 'remove_item', 'update_address', 'update_delivery_location_type', 'update_note', 'update_source']
  },
  {
    module: 'order_notes',
    actions: ['list', 'group', 'details', 'create', 'update', 'change_status', 'delete', 'restore']
  },
  {
    module: 'order_sources',
    actions: ['list', 'group', 'details', 'create', 'update', 'change_status', 'delete', 'restore']
  },
  {
    module: 'pdfs',
    actions: ['upload', 'list', 'group', 'details', 'update', 'delete', 'download', 'restore']
  },
  {
    module: 'payment_gateways',
    actions: ['list', 'group', 'details', 'update']
  },
  {
    module: 'pos',
    actions: ['list', 'group', 'details', 'place_order', 'cancel_order', 'return_order']
  },
  {
    module: 'products',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore', 'import', 'export']
  },
  {
    module: 'product_variations',
    actions: ['create', 'update', 'delete', 'restore']
  },
  {
    module: 'product_attributes',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'product_attribute_values',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'recharges',
    actions: ['initiate']
  },
  {
    module: 'analytics',
    actions: ['overview', 'products', 'traffic', 'themes', 'performance']
  },
  {
    module: 'reports',
    actions: ['orders', 'customers', 'sales_by_product', 'sales_by_payment_method']
  },
  {
    module: 'reviews',
    actions: ['list', 'group', 'details', 'update', 'delete', 'restore']
  },
  {
    module: 'stocks',
    actions: ['list', 'group', 'details', 'purchase', 'transfer', 'return', 'adjust']
  },
  {
    module: 'suppliers',
    actions: ['list', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'roles',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'terminals',
    actions: ['list', 'group', 'details', 'create', 'update', 'delete', 'restore']
  },
  {
    module: 'users',
    actions: ['manage']
  },
  {
    module: 'wishlists',
    actions: ['list', 'details']
  },
  {
    module: 'cache',
    actions: ['rehydrate', 'invalidate']
  },
];
